// src/sim/hiding/constants.ts — P3 hiding tunable constants (HIDE-01..07).
//
// Invariants:
//   - No side effects; module-level numeric constants only.
//   - Tick-count or pixel/tile-based (never milliseconds, never raw float seconds).
//   - Mark P7-tunable values with `// TODO(P7): retune from playtest`.
//
// Source: .planning/phases/03-core-sim-primitives/03-CONTEXT.md D-20, D-22, D-23, D-24, D-25
//         + .planning/phases/03-core-sim-primitives/03-UI-SPEC.md §HUD context-button hysteresis.

/** D-20: enter threshold for hide-candidate arming. 64 px = 2 tiles at current
 *  tileWidth. Bumped from 32 after UAT Test 7 feedback — "should be slightly
 *  easier to get into hiding spot"; the old 1-tile value required standing
 *  basically on the authored centre, which fights wall-clamp geometry near
 *  wall-adjacent spots. 2 tiles is "stand visibly next to the pot/tree". */
export const P3_HIDING_SPOT_ACTIVATION_RADIUS_PX = 64;

/** UI-SPEC §HUD context-button hysteresis — exit threshold.
 *  72 px = 2.25 tiles (8 px deadband preserved). */
export const P3_HIDING_SPOT_HYSTERESIS_PX = 72;

/** D-21 auto-release for peek. 1.5 s at 30 Hz = 45 ticks. */
export const P3_PEEK_MAX_DURATION_TICKS = 45;

/** D-24 peek cone half-angle. 22.5° × 2 = 45° total cone. */
export const P3_PEEK_CONE_HALF_ANGLE_RAD = Math.PI / 8;

/** D-24 peek cone range in TILES. */
export const P3_PEEK_CONE_RANGE_TILES = 4;

/** D-24 peek visibility penalty added to sightability when status='peeking'. */
export const P3_PEEK_VISIBILITY_PENALTY = 0.3;

/** D-23 on-floor synthetic spot skillMod. Lower than typical tree/pot spots (0.5). */
export const P3_ON_FLOOR_SKILL_MOD = 0.4;
